import Wizard from "./components/AccountCreationWizard/AccountWizard";

export default Wizard;
